/**
 * Checks if a stage has any tracked cards.
 * @param {Object} stage - The stage object.
 * @returns {boolean} True if the stage has tracked cards, false otherwise.
 */
export default function stageHasTrackedCards(stage, numberOfAllowedCards = 1) {
    if (!stage || !Array.isArray(stage.items)) return false;
    
    const trackedCards = stage.items.filter(item => item.is_tracked_by_current_user);

    return { result: trackedCards.length >= numberOfAllowedCards , cards: trackedCards ? trackedCards : [] };
}